import React from 'react'

import { useMessage } from '../../hooks/message'
import { usePostRequest } from '../../hooks/request'
import { EXPENSE_REPORT_LIST } from '../../urls'
import ExpenseForm from './expense-create-form'

export default function ExpenseCreate({ onCancel, categoryList, expenseReport, brandList }) {
    const products = usePostRequest({ url: EXPENSE_REPORT_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success, error } = await products.request({ data })
        if (success) {
            expenseReport.request()
            onCancel()
            showMessage('Успешно добавлен', 'is-success')
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Добавить Отчет о затратах</b>
            </h1>

            <ExpenseForm loading={products.loading} categoryList={categoryList} brandList={brandList} onCancel={onCancel} onSubmit={onSubmit} />
        </div>
    )
}
